import type { PropsOf } from '@emotion/react';
import type { StyledComponent } from '@emotion/styled';
import styled from '@emotion/styled';
import { DropdownMenu, tokens } from '@hotjar/hotsauce';
import type { RefAttributes } from 'react';
import { ItemWithCounter } from './ItemWithCounter';

interface NavListComponent extends StyledComponent<RefAttributes<HTMLUListElement>, PropsOf<'ul'>> {
  Item: typeof DropdownMenu.Item;
  LinkItem: typeof DropdownMenu.LinkItem;
  ItemWithCounter: typeof ItemWithCounter;
}

export const NavList = styled.ul`
  list-style: none;
  margin: 0;
  padding: ${tokens.spacer.x1} 0;
` as unknown as NavListComponent;

NavList.Item = DropdownMenu.Item;
NavList.LinkItem = DropdownMenu.LinkItem;
NavList.ItemWithCounter = ItemWithCounter;
